import { RouteType } from "types/RouteType";
import type { RootStore } from "@intrasync/stores";
import AssetTransactionsStore from "./AssetTransactions.Store";

/**
 * Asset Transactions Route
 *
 * View for tracking and documenting asset account transactions
 * per Implementation Plan Phase 1: GL Controls & Asset Tracking (1.2)
 *
 * Features:
 * - List all transactions posted to asset GLs (1xxx accounts)
 * - Filter by date, type, plant, acknowledgment status
 * - Acknowledge/approve asset transactions
 * - Export for CPA documentation
 */
const assetTransactionsRoute: RouteType = {
  name: "Asset Transactions",
  path: "/accounting/asset-transactions",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Asset Transactions",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./AssetTransactions.Header"),
    },
    body: {
      component: () => import("./AssetTransactions.Body"),
      grayBackground: true,
    },
  },
  group: "Accounting",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  showCompanySelector: true,
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    const store = (rootStore as any).assetTransactionsStore as AssetTransactionsStore;
    if (store) {
      await store.loadData();
    }
    return true;
  },
  onParamsChange: async ({ rootStore }: { rootStore: RootStore }) => {
    const store = (rootStore as any).assetTransactionsStore as AssetTransactionsStore;
    if (store) {
      await store.loadData();
    }
  },
  dialogs: [
    {
      name: "acknowledgeTransaction",
      title: "Acknowledge Asset Transaction",
      component: () => import("./dialogs/AcknowledgeDialog.Body"),
      cancelButton: true,
      height: 350,
    },
  ],
};

export default assetTransactionsRoute;
